import { Component, Inject } from '@angular/core';
import { ComponentDialogScheduleProperties } from './component.dialog.schedule.properties';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { EntityFormSchedule } from 'src/app/5.transversal/5.1.entity/entity.form.schedule';
import { ContractRepositoryScheduleSettingOutput } from 'src/app/4.repository/4.2.contract/contract.schedule.setting/contract.repository.schedule.setting';
import { EntityScheduleSetting } from 'src/app/5.transversal/5.1.entity/entity.schedule.setting';
import { RepositoryScheduleSetting } from 'src/app/4.repository/repository.schedule.setting';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { ComponentDialogAlert } from '../component.dialog.alert/component.dialog.alert';
import { UtilTitle, UtilMessages } from 'src/app/5.transversal/5.2.utils/util.constants';
import { ComponentDialogAlertType } from '../component.dialog.alert/component.dialog.alert.interface';
import { UtilApplication } from 'src/app/5.transversal/5.2.utils/util.application/util.application';
import { RepositoryUserRegister } from 'src/app/4.repository/repository.user.register';
import { ContractRepositoryUserRegisterOutput } from 'src/app/4.repository/4.2.contract/contract.user.register/contract.repository.user.register';

@Component({
    templateUrl: './component.dialog.schedule.html',
    styleUrls: ['./component.dialog.schedule.css']
})
export class ComponentDialogSchedule implements 
    ContractRepositoryScheduleSettingOutput,
    ContractRepositoryUserRegisterOutput
{
    
    public dataDialog: ComponentDialogScheduleProperties;
    public formSchedule: FormGroup;
    public formGroup: EntityFormSchedule = {
        fieldDate: new FormControl(new Date(), [Validators.required]),
        fieldHour: new FormControl(null, [Validators.required])
    }
    public listHoursAndMinutes: string[] = [];
    public currentDate: Date = new Date();
    public showHeaderError: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<ComponentDialogSchedule>,
        private formBuilder: FormBuilder,
        private repoScheduleSetting: RepositoryScheduleSetting,
        private spinner: NgxSpinnerService,
        private dialog: MatDialog,
        private appUtils: UtilApplication,
        private repoUserRegister: RepositoryUserRegister,
        @Inject(MAT_DIALOG_DATA) public data: ComponentDialogScheduleProperties
    ){
        this.dataDialog = data;
        this.repoUserRegister.repoUserRegisterOutput = this;
        this.repoScheduleSetting.repoSecheduleSettingListOutput = this;
        this.formSchedule = this.formBuilder.group(this.formGroup);
        this.repoSecheduleSettingSuccessfulOutput(this.dataDialog.scheduleDate);
    }

    onDateChange(newDate: MatDatepickerInputEvent<Date>){
        this.spinner.show();
        this.dataDialog.scheduleDate.day = newDate.value.getDate();
        this.dataDialog.scheduleDate.month = (newDate.value.getMonth() + 1);
        this.dataDialog.scheduleDate.year = newDate.value.getFullYear();
        this.dataDialog.scheduleDate.dayOfWeek = newDate.value.getDay();
        this.repoScheduleSetting.repoGetSecheduleSettingList(
            newDate.value.getDate(), 
            (newDate.value.getMonth() + 1), 
            newDate.value.getFullYear(),
            newDate.value.getDay(),
            1
        );
    }

    onClickClose(){
        this.dialogRef.close(false);
    }

    onClickAccept(){
        let dateSelected = (this.formGroup.fieldDate.value as Date);
        let hourSelected = (this.formGroup.fieldHour.value as string);
        if(this.formGroup.fieldHour.valid){
            this.spinner.show();
            var _hour = Number(hourSelected.substring(0,2));
            let _min = this.appUtils.convertTwoDigits(Number(hourSelected.substring(3,5)));
            let _meridian = hourSelected.substring(6,8);
            if(_meridian == 'PM' && _hour != 12){
                _hour = (_hour + 12);
            }
            let _year = dateSelected.getFullYear();
            let _month = this.appUtils.convertTwoDigits(dateSelected.getMonth());
            let _day = this.appUtils.convertTwoDigits(dateSelected.getDate());
            var startTime = new Date(); 
            var endTime = new Date(_year, Number(_month), Number(_day), _hour, Number(_min), 0, 0);
            var difference = endTime.getTime() - startTime.getTime();
            var resultInMinutes = Math.round(difference / 60000);
            this.repoUserRegister.repoUserRegister(
                this.dataDialog.dataToCall.name,
                this.dataDialog.dataToCall.cellphone,
                this.dataDialog.dataToCall.email,
                this.dataDialog.params,
                resultInMinutes,
                this.dataDialog.dataToCall.callMeNow
            );
        }else{
            this.dialog.open(ComponentDialogAlert, {
                data: {
                    title: UtilTitle.Error,
                    message: UtilMessages.dataIncomplete,
                    buttonText: 'Aceptar',
                    type: ComponentDialogAlertType.Error,
                    stopProcess: false
                },
                disableClose: true
            });
        }
    }

    repoSecheduleSettingSuccessfulOutput(data: EntityScheduleSetting): void {
        this.spinner.hide();
        this.listHoursAndMinutes = [];
        var minutesValidation = true;
        var initHourValidation = data.initHour;
        if(this.currentDate.getFullYear() == data.year && (this.currentDate.getMonth() + 1) == data.month && this.currentDate.getDate() == data.day){
            minutesValidation = false;
            if(initHourValidation > this.currentDate.getHours()){
                initHourValidation = this.data.scheduleDate.initHour;
            }else{
                initHourValidation = this.currentDate.getHours();
            }
        }
        for(let i = Number(initHourValidation); i <= Number(data.finalHour); i++){
            var initMinValidation = 0;
            var finalMinValidaction = 5;
            if(minutesValidation){
                if(i == Number(initHourValidation)){
                    if(Number(data.initMinute) != 0){
                        initMinValidation = (Number(data.initMinute) / 10);
                    }else{
                        initMinValidation = 0;
                    }
                }else if(i == Number(data.finalHour)){
                    if(Number(data.finalMinute) != 0){
                        finalMinValidaction = (Number(data.finalMinute) / 10);
                    }else{
                        finalMinValidaction = 0;
                    }
                }
            }else{
                if(i == Number(initHourValidation) && this.currentDate.getHours() == Number(initHourValidation)){
                    if(this.currentDate.getMinutes() == 0){
                        initMinValidation = 0;
                    }else if(this.currentDate.getMinutes() > 0 && this.currentDate.getMinutes() <= 10){
                        initMinValidation = 1;
                    }else if(this.currentDate.getMinutes() > 10 && this.currentDate.getMinutes() <= 20){
                        initMinValidation = 2;
                    }else if(this.currentDate.getMinutes() > 20 && this.currentDate.getMinutes() <= 30){
                        initMinValidation = 3;
                    }else if(this.currentDate.getMinutes() > 30 && this.currentDate.getMinutes() <= 40){
                        initMinValidation = 4;
                    }else {
                        initMinValidation = 5;
                    }
                }else {
                    if(Number(data.initMinute) != 0){
                        initMinValidation = (Number(data.initMinute) / 10);
                    }else{
                        initMinValidation = 0;
                    }
                }

                if(i == Number(data.finalHour)){
                    if(Number(data.finalMinute) != 0){
                        finalMinValidaction = (Number(data.finalMinute) / 10);
                    }else{
                        finalMinValidaction = 0;
                    }
                }
            }
            for(let x = initMinValidation; x <= finalMinValidaction; x++){
                var hours = this.appUtils.convertTwoDigits(i);
                let minutes = this.appUtils.convertTwoDigits(x * 10);
                if(i == 12){
                    if((x * 10) == 0){
                        this.listHoursAndMinutes.push(`${hours}:${minutes} M`);
                    }else{
                        this.listHoursAndMinutes.push(`${hours}:${minutes} PM`);
                    }
                }else if(i > 12){
                    hours = this.appUtils.convertTwoDigits(i - 12);
                    this.listHoursAndMinutes.push(`${hours}:${minutes} PM`);
                }else{
                    this.listHoursAndMinutes.push(`${hours}:${minutes} AM`);
                }
            }
        }
        if(this.listHoursAndMinutes != null && this.listHoursAndMinutes.length > 0){
            this.showHeaderError = false;
        }else{
            this.showHeaderError = true;
        }
    }

    repoSecheduleSettingFailureOutput(): void {
        this.spinner.hide();
        this.dialog.open(ComponentDialogAlert, {
            data: {
                title: UtilTitle.Error,
                message: UtilMessages.errorLoadDateSetting,
                buttonText: 'Aceptar',
                type: ComponentDialogAlertType.Error,
                stopProcess: false
            },
            disableClose: true
        });
    }

    repoRegisterUserSuccessfulOutput(): void {
        this.spinner.hide();
        this.dialogRef.close(true);
    }

    repoRegisterUserFailureOutput(): void {
        this.spinner.hide();
        this.dialog.open(ComponentDialogAlert, {
            data: {
                title: UtilTitle.Error,
                message: UtilMessages.genericError,
                buttonText: 'Aceptar',
                type: ComponentDialogAlertType.Error,
                stopProcess: false
            },
            disableClose: true
        });
    }

}